import styled from 'styled-components';

export const Box = styled.div`
  position: fixed;
  bottom: ${({ theme }) =>
    theme.isWebView ? `${+theme.insetsBottom + 15}px` : '15px'};
  right: 15px;
  left: 15px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  z-index: 9;
`;
